import './chip.css';
export default {
  "badge": "pf-v5-c-badge",
  "button": "pf-v5-c-button",
  "chip": "pf-v5-c-chip",
  "chipActions": "pf-v5-c-chip__actions",
  "chipContent": "pf-v5-c-chip__content",
  "chipIcon": "pf-v5-c-chip__icon",
  "chipText": "pf-v5-c-chip__text",
  "modifiers": {
    "overflow": "pf-m-overflow",
    "draggable": "pf-m-draggable"
  },
  "themeDark": "pf-v5-theme-dark"
};